export enum ESolarSolutionType {
  SOLAR_ENERGY_SYSTEM = "SOLAR_ENERGY_SYSTEM",
  WATER_HEATING_SYSTEM = "WATER_HEATING_SYSTEM",
  BOTH = "BOTH",
}
